export const CIVIL_3D_SETTING_DUPLICATE_COUNT_LIMIT = 1000;

export const CIVIL_3D_SETTING_CONFIGURATION_DUPLICATE_COUNT_LIMIT = 3;
